import React from "react";
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { DialogEnums, StyleEnums } from "models/enums";
//#endregion
//#region components
import RemoveEmployeeFormContainer from "./forms/removeEmployeeFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useRemoveEmployeeDialog() {
  const removeEmployeeDialog = (
    employee: WintSuperkollAPIModel.EmployeeItem,
    onRemoveEmployeeSubmitSuccess?: (values: any) => void
  ): DialogProps => {
    return {
      isOpen: false,
      id: "removeEmployee",
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.RemoveEmployeeTitle),
      dialogType: DialogEnums.DialogType.Content,
      type: StyleEnums.DisplayType.Danger,
      children: (
        <RemoveEmployeeFormContainer
          id={employee.id}
          name={employee.name ?? ""}
          isSalaryActive={employee.salaryInfo?.isActive ?? false}
        />
      ),
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Remove),
          successMessage: TranslationKeys.Settings.RemoveEmployeeSucces,
          type: StyleEnums.DisplayType.Danger,
        },
      ],
      onSubmit: onRemoveEmployeeSubmitSuccess,
      maxWidth: "sm",
    };
  };

  return removeEmployeeDialog;
}

export default useRemoveEmployeeDialog;
